import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Checkbox } from '@/components/UI/Checkbox/Checkbox';

export const DrawerItemTitle = styled(Typography.Title)`
  padding: 5px 0;
  color: ${({ theme }) => theme.palette.primary.labels};
  font-size: 16px;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ListItem = styled(Checkbox)<{ $order?: number }>`
  order: ${({ $order }) => $order || 1};
  height: 40px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 50px;
  }
`;

export const CheckboxAction = styled(Typography.Caption)`
  white-space: nowrap;
  color: ${({ theme }) => theme.palette.system.blue};
`;

export const CardBox = styled.div<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  height: 60px;
  padding: 0 15px;
  border-radius: 14px;
  border: 1px solid
    ${({ theme, $isActive }) =>
      $isActive ? theme.palette.system.blue : theme.palette.primary.border};
  background-color: ${({ theme, $isActive }) =>
    $isActive
      ? theme.palette.secondary.background
      : theme.palette.primary.background};
  margin-top: 10px;
  cursor: pointer;

  &:last-child {
    margin-bottom: 10px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    &:last-child {
      margin-bottom: 35px;
    }
  }
`;

export const CardName = styled(Typography.Body)`
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
